import { FaCheck, FaPencilAlt } from 'react-icons/fa';
import api from '../../../../services/api';
import { useAuth } from '../../../../hooks/auth';

import { useCustomTheme } from '../../../../hooks/useCustomTheme';
import { Container, Description } from './styles';
import { CustomButton } from '../../../../components/CustomButton';
import { Spacer } from '../../../../components/Spacer';
import { AddProducts } from '../AddProducts';
import { useState } from 'react';

export function ListItem({
  item,
  montagemProduto,
  product,
  listarMontagensProduto,
  handleEditModal,
}) {
  const { theme } = useCustomTheme();
  const { id_empresa } = useAuth();
  const [modalProdutos, setModalProdutos] = useState(false);

  const isUsing = !!montagemProduto;

  function addMontagemProduto(montagem) {
    api
      .post('/produto-montagens/criar', {
        IdEmpresa: id_empresa,
        IdMontagemPrato: montagem?.Id,
        IdProduto: product?.Id,
      })
      .then((res) => {
        listarMontagensProduto();
      })
      .catch((err) => console.error(err));
  }

  function removeMontagemProduto(montagem) {
    api
      .delete(`/produto-montagens/deletar/${montagem.Id}`)
      .then((res) => {
        listarMontagensProduto();
      })
      .catch((err) => console.error(err));
  }

  return (
    <Container key={item?.Id} montagemProduto={isUsing}>
      <Description
        onClick={() =>
          isUsing
            ? removeMontagemProduto(montagemProduto)
            : addMontagemProduto(item)
        }
        isUsing={isUsing}
      >
        {item.Descricao}
      </Description>
      <div style={{ display: 'flex', gap: '20px' }}>
        {isUsing && (
          <FaCheck
            size={18}
            color={isUsing ? theme.colors.white : theme.colors.text}
            style={{ cursor: 'pointer' }}
            onClick={() =>
              isUsing
                ? removeMontagemProduto(montagemProduto)
                : addMontagemProduto(item)
            }
          />
        )}
        <div onClick={() => handleEditModal(item)}>
          <FaPencilAlt
            size={18}
            style={{ cursor: 'pointer' }}
            color={isUsing ? theme.colors.white : theme.colors.text}
          />
        </div>
      </div>
      <Spacer x={20} />
      <div>
        <CustomButton
          appearance="ghost"
          color={isUsing ? theme.colors.white : theme.colors.primary}
          onClick={() => setModalProdutos((prev) => !prev)}
        >
          Produtos
        </CustomButton>
      </div>
      <AddProducts
        open={modalProdutos}
        onClose={() => setModalProdutos((prev) => !prev)}
        montagem={item}
        product={product}
      />
    </Container>
  );
}
